export default __webpack_public_path__ + "static/media/company.72ea8375.svg";